if (!customElements.get("shoppable-drawer")) {
  customElements.define(
    "shoppable-drawer",
    class ShoppableDrawer extends HTMLElement {
      constructor() {
        super();
        this.initilize();
      }

      initilize() {
        this.clickHandler = this.clickHandler.bind(this);
        this.closeHandler = this.closeHandler.bind(this);
        this.updateEventListeners = this.updateEventListeners.bind(this);
        this.deviceType = "";
        this.isOpen = this.dataset.open;
        this.body = document.querySelector("body");
        this.container = document.querySelector(".wt__shoppable-image");
        this.wrapper = document.querySelector(".wt__shoppable-image--wrapper");
        this.shoppableBody = document.getElementById("shoppable-image__body");
        this.shoppableImagesBody = document.querySelectorAll(
          ".shoppable-image__body",
        );
        this.pageOverlay = document.querySelector(
          ".wt__shoppable-image--page-overlay",
        );
        this.productContent = this.querySelector(".wt-dot__tooltip a");
        this.tooltip = this.querySelector(".wt-dot__tooltip");

        this.button = this.querySelector(".wt-dot__circle");
        this.closeButton = document.querySelector(".wt-options__title svg");
        this.handleHideTooltips = this.handleHideTooltips.bind(this);

        if (window.innerWidth < 900) this.updateEventListeners();
        this.addDotEventListeners();
      }

      connectedCallback() {
        this.updateEventListeners();
        this.shoppableImagesBody.forEach((link) => {
          this.handleAddListenerToHideTooltips(link);
        });
        window.addEventListener("resize", this.handleResize);
        document.addEventListener("click", this.handleHideTooltips);
      }

      addDotEventListeners() {
        // Store references to dots with event listeners for proper cleanup
        this.dotsWithListeners = [];
        
        // Add event listeners to all dots
        document.querySelectorAll(".wt-dot").forEach((dot) => {
          // Add event listeners
          dot.addEventListener("click", this.handleDotClick);
          dot.addEventListener("keydown", this.handleDotKeydown);
          
          // Store reference for cleanup
          this.dotsWithListeners.push(dot);
        });
      }

      handleDotClick = (event) => {
        event.preventDefault();
        this.toggleTooltip(event.srcElement.parentElement.nextElementSibling);
      };

      handleDotKeydown = (event) => {
        if (event.key === "Enter" || event.keyCode === 13) {
          event.preventDefault();
          this.toggleTooltip(event.srcElement.parentElement.nextElementSibling);
        }
      };

      toggleTooltip(tooltip) {
        // Cache the visibility state before making DOM changes
        const isHidden = window.getComputedStyle(tooltip).getPropertyValue("visibility") === "hidden";
        
        // Use requestAnimationFrame to batch DOM operations
        requestAnimationFrame(() => {
          // First hide all tooltips
          this.hideAllTooltips();
          
          // Then show this tooltip if it was previously hidden
          if (isHidden) {
            this.showTooltip(tooltip);
          }
        });
      }

      hideAllTooltips() {
        // Get all tooltips first to avoid multiple DOM queries
        const tooltips = Array.from(document.getElementsByClassName("wt-dot__tooltip"));
        
        // Use requestAnimationFrame to batch style updates
        requestAnimationFrame(() => {
          // Apply all style changes in a batch to avoid forced reflows
          tooltips.forEach((tooltip) => {
            // Apply both style changes at once
            Object.assign(tooltip.style, {
              visibility: "hidden",
              opacity: 0
            });
          });
        });
      }

      showTooltip(tooltip) {
        // Use requestAnimationFrame to batch style updates
        requestAnimationFrame(() => {
          // Apply both style changes at once to avoid forced reflow
          Object.assign(tooltip.style, {
            visibility: "visible",
            opacity: 1
          });
        });
      }

      handleResize = () => {
        this.updateEventListeners();
      };

      handleAddListenerToHideTooltips(link) {
        // Create a named handler function and store it on the element
        // This allows us to properly remove it later
        link._hideTooltipsHandler = (event) => {
          if (this.isClickOutside(event)) {
            this.hideTooltips();
          }
        };
        
        // Add the event listener with the stored handler
        link.addEventListener("click", link._hideTooltipsHandler);
      }

      handleRemoveListenerToHideTooltips(link) {
        // Only remove if the handler exists
        if (link._hideTooltipsHandler) {
          link.removeEventListener("click", link._hideTooltipsHandler);
          // Clean up the reference
          delete link._hideTooltipsHandler;
        }
      }

      handleHideTooltips(event) {
        let isInsideShoppableBody = event.target.closest(
          ".shoppable-image__body",
        );
        if (!isInsideShoppableBody) {
          this.hideTooltips();
        }
      }

      hideTooltips() {
        // Read phase - determine resolution
        const resolution = this.matchResolution();
        
        if (resolution === "mobile") {
          // Use existing optimized closeHandler
          this.closeHandler();
        } else {
          // Batch DOM operations for desktop resolution
          requestAnimationFrame(() => {
            // Read phase - get all tooltips
            const tooltips = Array.from(document.getElementsByClassName("wt-dot__tooltip"));
            
            // Write phase - update all tooltips in a batch
            requestAnimationFrame(() => {
              tooltips.forEach(tooltip => {
                // Apply both style changes at once
                Object.assign(tooltip.style, {
                  visibility: "hidden",
                  opacity: 0
                });
              });
            });
          });
        }
      }

      isClickOutside(event) {
        return !(
          (
            event.target.classList.contains("wt-dot__circle") ||
            event.target.classList.contains("wt-dot__ringing") ||
            event.target.closest(".wt-dot__tooltip")
          ) // Add this to keep the tooltip if clicked inside it
        );
      }

      updateEventListeners() {
        // Read phase - determine current resolution and state
        const currentResolution = this.matchResolution();
        const resolutionChanged = currentResolution !== this.deviceType;
        const isMobile = currentResolution === "mobile";
        const isDesktop = currentResolution === "desktop";
        
        // Only proceed if resolution has changed
        if (!resolutionChanged) return;
        
        // Update event listeners based on resolution
        if (isMobile) {
          // Add mobile event listeners
          if (this.button) {
            this.button.addEventListener("click", this.clickHandler);
            this.button.addEventListener("keydown", this.enterKeyHandler);
          }
          
          if (this.closeButton) {
            this.closeButton.addEventListener("click", this.closeHandler);
          }
          
          // Schedule visual updates
          requestAnimationFrame(() => {
            if (this.tooltip) this.tooltip.style.display = "none";
          });
        } else if (isDesktop) {
          // Remove mobile event listeners
          if (this.button) {
            this.button.removeEventListener("click", this.clickHandler);
            this.button.removeEventListener("keydown", this.enterKeyHandler);
          }
          
          // Close any open mobile UI
          this.closeHandler();
          
          // Schedule visual updates
          requestAnimationFrame(() => {
            if (this.tooltip) this.tooltip.style.display = "initial";
          });
        }
        
        // Update stored device type
        this.deviceType = currentResolution;
      }

      enterKeyHandler = (event) => {
        if (event.key === "Enter" || event.keyCode === 13) {
          this.clickHandler(event);
        }
      };

      clickHandler() {
        // Update state first
        this.isOpen = true;
        
        // Use requestAnimationFrame to batch DOM operations
        requestAnimationFrame(() => {
          // Read phase - gather all necessary data
          const dotLinks = this.wrapper.querySelectorAll(".wt-dot__link");
          const productContentClone = this.productContent.cloneNode(true);
          
          // Write phase - perform all DOM modifications in a batch
          requestAnimationFrame(() => {
            // Remove existing dot links
            dotLinks?.forEach((element) => {
              element.remove();
            });
            
            // Update classes
            this.body.classList.add("shoppable-image-on");
            this.pageOverlay.classList.remove("hidden");
            
            // Append new content
            this.wrapper.appendChild(productContentClone);
            this.wrapper.classList.add("open");
          });
        });
      }

      closeHandler() {
        // Use requestAnimationFrame to batch DOM reads
        requestAnimationFrame(() => {
          // Read phase - gather all state information
          const hasBodyClass = this.body.classList.contains("shoppable-image-on");
          const isOverlayVisible = !this.pageOverlay.classList.contains("hidden");
          const isWrapperOpen = this.wrapper.classList.contains("open");
          
          // Write phase - perform all DOM modifications in a batch
          requestAnimationFrame(() => {
            // Update all classes at once
            if (hasBodyClass) this.body.classList.remove("shoppable-image-on");
            if (isOverlayVisible) this.pageOverlay.classList.add("hidden");
            if (isWrapperOpen) this.wrapper.classList.remove("open");
          });
        });
      }

      matchResolution() {
        if (window.innerWidth < 900) {
          return "mobile";
        } else {
          return "desktop";
        }
      }

      disconnectedCallback() {
        // Clean up button event listeners
        this.button?.removeEventListener("click", this.clickHandler);
        this.button?.removeEventListener("keydown", this.enterKeyHandler);
        this.closeButton?.removeEventListener("click", this.closeHandler);
        
        // Clean up window event listeners
        window.removeEventListener("resize", this.handleResize);
        
        // Clean up document event listeners
        document.removeEventListener("click", this.handleHideTooltips);
        
        // Clean up shoppable body event listeners
        if (this.shoppableImagesBody) {
          this.shoppableImagesBody.forEach((link) => {
            this.handleRemoveListenerToHideTooltips(link);
          });
        }
        
        // Clean up dot event listeners
        if (this.dotsWithListeners) {
          this.dotsWithListeners.forEach(dot => {
            dot.removeEventListener("click", this.handleDotClick);
            dot.removeEventListener("keydown", this.handleDotKeydown);
          });
          this.dotsWithListeners = [];
        }
      }
    },
  );
}
